// @ts-nocheck
export const sortAudienceVariablesArrayByOrder = (arr: Record<string, number>[]) => {
  return [...arr].sort((itemA, itemB) => {
    const orderA = itemA.order ?? 0;
    const orderB = itemB.order ?? 0;
    return orderA - orderB;
  });
};
